<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">
                <strong v-if="status_form==0">{{ $t('components.addProductUnit') }}</strong>
                <strong v-else>{{ $t('components.editProductUnit') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: center ;">

                <strong v-if="status_form!=0">{{edit_name}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" size="sm" class="mr-1 ml-1"  color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton v-if="status_form!=0" @click="emptyList()"
                         class="mr-1"
                         type="reset" size="sm" color="secondary">
                  {{ $t("buttons.cancel") }}
                </CButton>
                <a :href="$route.fullPath" target="_blank">
                  <CButton
                          class="mr-1 ml-1"
                          size="sm"
                      color="dark"
                  >
                    <CIcon size="sm" name="cil-plus"></CIcon>
                  </CButton>
                </a>
              </CCol>
            </CRow>
            <!--        </div>-->

            <!-- Right aligned nav items -->
            <!--      </CCollapse>-->
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol col="3">
                <CInput
                    :label="$t('components.unitName')"

                    v-model="name"
                    autocomplete="name"
                />
              </CCol>
              <CCol col="3">
                <CSelect
                    :label="$t('components.baseUnit')"
                    :options="templates_items"
                    :value.sync="selected_template"
                />
              </CCol>
              <CCol col="3">
                <CInput
                        :label="$t('components.baseCoefficient')"

                        type="number"
                      v-on:keypress="isNumber($event)"
                        v-model="multypyBase"
                        autocomplete="name"
                />

              </CCol>


            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow v-show="this.$route.path == '/dashboard/base/inventory-settings'">
      <CCol md="6">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="6">
                <strong>{{ $t('components.baseProductUnitsList') }}</strong>

              </CCol>
              <CCol col="6">
                <CSelect
                        :options="templates_items_filter"
                        :value.sync="selected_unit_parent_filter"
                />

              </CCol>
            </CRow>

          </CCardHeader>
          <CCardBody>

            <CDataTableFixed
                :items="items_filtered"
                :fields="fields"
                column-filter
                striped
                border
                @row-clicked="table_row_clicked"
height="280px"
                :items-per-page="10"
                hover
                sorter

            >
              <template #row_id="{item,index}">

                <td style="text-align: center">
                  <p >{{ index + 1 }}</p>

                </td>

              </template>
              <template #operation="{item}">
                <td>

<!--                  <CIcon @click.native="edit_item(item)" class=" mr-1 text-primary" name="cil-pencil"/>-->

                  <CIcon @click.native="delete_item_dialog(item)" class="mr-1 text-danger" name="cilTrash"/>

                </td>
              </template>


            </CDataTableFixed>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];

export default {
  name: 'Login',
  data() {
    return {

      name: '',
      edit_name: '',
      file: '',
      color: '#ffffff',
      previewImage: '',
      multypyBase: 1,
      selected_template: 0,
      description: '',
      table_clicks: 0,
      table_clicks_timer: null,
      items: [],
      items_filtered: [],
      fields: [
        {key: 'row_id', label: this.$t('tables.row'), _style: 'width:10%'},
        {key: 'unitName', label: this.$t('tables.name'), _style: 'width:20%'},
        {key: 'baseUnitName', label: this.$t('tables.base'), _style: 'width:20%'},
        {key: 'unitValue', label: this.$t('tables.ratio'), _style: 'width:10%'},


        {key: 'operation', label: "",filter:false, _style: 'width:10%;'},


      ],
      details: [],
      templates_items: [],
      templates_items_filter: [],
      selected_unit_parent_filter:0,
      collapseDuration: 0,
      status_form: 0,
      confirm_delete_name:"confirm_unit"+new Date().getTime()+"_"+this.$vnode.tag,

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'selected_unit_parent_filter': function () {

      if(this.selected_unit_parent_filter==0){
        this.items_filtered = this.items;
      }else{
        this.items_filtered = this.items.filter(x=>x.baseUnitId== this.selected_unit_parent_filter);
      }
    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.unitName;
      this.edit_name = item.unitName;
      this.selected_template = item.baseUnitId;
      this.multypyBase = item.unitValue;

      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetProductUnits', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
         self.items =  self.sort_array([],self.items,'id','unitName');

          self.items_filtered = self.items;

          // self.templates_items = content_data.data;
          self.templates_items = [];
          self.templates_items_filter = [];
          var obj = {label: self.$t('components.baseUnit'), value: 0}
          var obj_all = {label: self.$t('all'), value: 0}
          self.selected_unit_parent_filter =0;
          self.templates_items.push(obj);
          self.templates_items_filter.push(obj_all);
         var unit_parent = content_data.data.filter(x=>x.baseUnitId ==x.id);
          self.templates_items =  self.sort_array(self.templates_items,unit_parent,"id","unitName");
          self.templates_items_filter =  self.sort_array(self.templates_items_filter,unit_parent,"id","unitName");

          bus.$emit('close_add_base_modal', 'false');

          if(self.selected_unit_parent_filter==0){
            self.items_filtered = self.items;
          }else{
            self.items_filtered = self.items.filter(x=>x.baseUnitId== self.selected_unit_parent_filter);
          }

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item, index) {

      this.$router.push({path: '/categories/' + this.items[index].id});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    insert_data() {
      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddProductUnit";
      } else {
        url = "EditProductUnit";
        formData.append('id', this.status_form)

      }

      formData.append('BaseUnitId', this.selected_template);
      if (this.selected_template == 0) {
        formData.append('value', 1);

      } else {
        formData.append('value', this.multypyBase);

      }
      formData.append('unitName', this.name);
      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.selected_template = 0;
        self.multypyBase = 1;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });

    }, delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteProductUnit";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        //
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
